import { Button, Flex, ScrollView, TextField } from "@aws-amplify/ui-react";
import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

import { valueTypes } from "config/constants";
import ActionIcon from "components/actions/ActionIcon";

const DeviceActionValues = ({
  visible,
  deviceId,
  action,
  currentValue,
  onClose,
  sendAction,
}) => {
  const [fieldNumber, setFieldNumber] = useState();

  useEffect(() => {
    if (action.valueType === valueTypes[2]) setFieldNumber(currentValue);
  }, [action, currentValue]);

  return (
    <CModal
      alignment="center"
      visible={visible}
      onClose={onClose}
      backdrop="static"
    >
      <CModalHeader>
        <CModalTitle>
          {strings.formatString(strings.modalAction.title, {
            name: action.name,
          })}
        </CModalTitle>
      </CModalHeader>
      <CModalBody style={{ overflow: "hidden" }}>
        <ScrollView maxHeight="75vh">
          <Flex justifyContent="center" alignItems="end">
            {action.valueType === valueTypes[2] ? (
              <>
                <TextField
                  name="actionValue"
                  label={strings.modalAction.fieldNumber}
                  value={fieldNumber}
                  type="number"
                  onChange={(e) => setFieldNumber(e.target.value)}
                ></TextField>
                <Button
                  children={strings.modalAction.sendButton}
                  loadingText={strings.modalAction.sendButton}
                  onClick={() =>
                    sendAction(
                      deviceId,
                      action.id,
                      `${action.shortName}:${fieldNumber}`,
                      action.successMsg,
                      action.errorMsg,
                      true
                    )
                  }
                  variation="primary"
                  isDisabled={!fieldNumber?.length}
                ></Button>
              </>
            ) : (
              action.values?.map((val) => (
                <div style={{ padding: "2px" }}>
                  <ActionIcon
                    name={val.name}
                    icon={val.icon}
                    color={val.iconColor}
                    onClick={() =>
                      sendAction(
                        deviceId,
                        action.id,
                        `${action.shortName}:${val.value}`,
                        val.successMsg,
                        val.errorMsg,
                        true
                      )
                    }
                    showName
                    isSelected={currentValue === val.value}
                  />
                </div>
              ))
            )}
          </Flex>
        </ScrollView>
      </CModalBody>
    </CModal>
  );
};

const strings = new LocalizedStrings({
  es: {
    modalAction: {
      title: "Elegir valor de la acción {name}",
      fieldNumber: "Ingrese número",
      sendButton: "Enviar",
    },
  },
});

export default DeviceActionValues;
